var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcbBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 9h-11v2h-4v-2h-26v2h-4v-2h-11c-1.654 0-3 1.346-3 3v40c0 1.654 1.346 3 3 3h11v-2h4v2h26v-2h4v2h11c1.654 0 3-1.346 3-3v-40c0-1.654-1.346-3-3-3zm1 43c0 .552-.449 1-1 1h-9v-2h-8v2h-22v-2h-8v2h-9c-.551 0-1-.448-1-1v-40c0-.552.449-1 1-1h9v2h8v-2h22v2h8v-2h9c.551 0 1 .448 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 35h6v-6h-6zm2-4h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 39h14v-14h-14zm2-12h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 17h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 13h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 17h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 49h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 41h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 49h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 41h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 49h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 41h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 49h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 41h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 25h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 25h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 29h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 29h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 33h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 33h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 37h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 37h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 25h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 25h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 29h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 29h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 33h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 33h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 37h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 37h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 45c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 45c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 21h2v22h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 21h2v22h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcbBoard);
export default __webpack_public_path__ + "static/media/pcb-board.2ca1a8bab3ced778e2d47dd1ed602606.svg";
export { ForwardRef as ReactComponent };